import './contacts.scss';

function Contacts() {
    return (
        <div className='contacts-container'>
            <a href='mailto:antoniocozzi2@gmail.com'>antoniocoz&zwnj;zi2@gmail.com</a>
        </div>
    );
}

export default Contacts;